import React from 'react';
import moment from 'moment';
import '../../css/formats.css';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

class CashCut extends React.Component {


    render() {
       
        return (
            <div>
                <div className='row'>
                    <div className='col-4'></div>
                    <div className='col-4'>
                        <div style={{ backgroundColor: 'white', width: "322px", height: "auto", marginLeft: "auto", marginRight: "auto", border: "solid 1px" }}>
                            <div className='row p-2'>
                                <div className='col-12 text-center'>
                                    <span><strong>CORTE TOTAL</strong></span>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-12 text-center text-ticket">
                                    <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" style={{ maxWidth: "170px" }} />
                                    <p><strong>{Datos_Empresa.Nombre}<br />{Datos_Empresa.Sociedad}<br /></strong></p>
                                    <p >COL. C.P.;,.</p>
                                    <span >Tel. TEL_{Datos_Empresa.Name} Cel. CEL_{Datos_Empresa.Name}</span>
                                </div>
                            </div>
                            <div className='row p-3'>
                                <div className='col-12 text-ticket '>
                                    <table>
                                        <tbody style={{ borderBottom: "solid 2px" }}>
                                            <tr>
                                                <td>FECHA: </td>
                                                <td className='text-right' style={{ fontWeight: "bold" }}>00/00/00 00:00</td>
                                            </tr>
                                            <tr>
                                                <td>USUARIO: </td>
                                                <td className='text-right'>OSVALDO GALINDO</td>
                                            </tr>
                                            <br />
                                            
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket '>
                                    
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>EFECTIVO:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>                                                       
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>CHEQUE:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                <td className='text-left'>000000</td>
                                                <td className='text-right'>0.00</td>
                                            </tr>
                                                    
                                            <br />
                                            
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>TARJETA:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                <td className='text-left'>000000</td>
                                                <td className='text-right'>0.00</td>
                                            </tr>
                                                    
                                            <br />
                                            
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>TRANSFERENCIA:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                <td className='text-left'>000000</td>
                                                <td className='text-right'>0.00</td>
                                            </tr>
                                                    
                                            <br />
                                            
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>DEVOLUCION COMO PAGO:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                <td className='text-left'>000000</td>
                                                <td className='text-right'>0.00</td>
                                            </tr>
                                                    
                                            <br />
                                            
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>CREDITO:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>                                                        
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>NOTAS DE CREDITO:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>                                                        
                                    </table>
                                    <br />
                                    <table>
                                        <thead>
                                            <tr style={{ borderTop: "solid 2px" }}>
                                                <th>ENTRADAS DE DINERO:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                <td className='text-left'>000000</td>
                                                <td className='text-right'>0.00</td>
                                            </tr>
                                                    
                                            <br />
                                            
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>SALIDAS DE DINERO:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                <td className='text-left'>000000</td>
                                                <td className='text-right'>0.00</td>
                                            </tr>
                                                    
                                            <br />
                                            
                                        </tbody>
                                    </table>
                                    <br />
                                    <table>
                                        <thead>
                                            <tr style={{ borderTop: "solid 2px" }}>
                                                <th>VENTAS:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>DEVOLUCIONES:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>COBRANZA:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>ENTRADAS Y SALIDAS:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <br />
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>TOTAL:</th>
                                                <th className='text-right'>$0.00</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <br />
                                    <p><br /></p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className='col-4'></div>

                </div>

            </div>
        )
    }
}

export default CashCut